var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('custom-animation',{staticClass:"hour-glass",attrs:{"data":_vm.animationData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }